import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as ArrowIcon } from "../../../../../assets/images/habitacional/arrow-icon.svg";
import * as S from "./MenuLinkItem.style";

const MenuLinkItem = ({ menuLink, isEnableActiveClass }) => {
  const isExternalLink = menuLink?.isExternalLink;
  const target = isExternalLink ? "_blank" : "_self";

  const currentClassName = () => {
    if (!isEnableActiveClass) {
      return "";
    }

    const isActive =
      window.location.pathname === menuLink.href ||
      menuLink?.submenu?.find(
        (submenu) => window.location.pathname === submenu.href
      );

    return isActive ? "active" : "";
  };

  const handleClick = (event) => {
    if (Array?.isArray(menuLink?.submenu)) {
      event.preventDefault();
    }
  };

  return (
    <S.MenuLinkItem
      href={menuLink.href}
      target={target}
      onClick={handleClick}
      className={currentClassName()}
    >
      {menuLink.label}
      {menuLink?.submenu && (
        <div className="icon">
          <ArrowIcon width="24px" height="24px" />
        </div>
      )}
    </S.MenuLinkItem>
  );
};

export default MenuLinkItem;

MenuLinkItem.propTypes = {
  menuLink: PropTypes.objectOf(Object),
  isEnableActiveClass: PropTypes.bool,
};

MenuLinkItem.defaultProps = {
  menuLink: {},
  isEnableActiveClass: true,
};
